export default "/assets/images/mila-valentine-mobile-b-w.5e491aa845fc2c83.webp";